import { BestuurlijkeGebiedenRoute } from "../models/bestuurlijkeGebieden/bestuurlijkeGebiedenRoute";
import { BaseWebService } from "./base.web.service";

export class BestuurlijkeGebiedenWebService extends BaseWebService {

    public async getBestuurlijkeGebiedenRoutes() {
        const params = this.appendParam('', 'options', 'test');
        const headers = await this.getHeadersJson(false);
        const url = `${this.appConfig.serviceBestuurlijkeGebiedenUrl}/api/bestuurlijkegebieden/routes${params}`;
        return this.makeRequest(url, 'GET', headers);
    }

    public async getBestuurlijkeGebiedenByRoute(route: string) {
        const params = this.appendParam('', 'properties', 'api');
        const headers = await this.getHeadersJson(false);
        const url = `${this.appConfig.serviceBestuurlijkeGebiedenUrl}/${route}${params}`;
        return this.makeRequest(url, 'GET', headers);
    }

    public async autocompleteByTypeAndName(type: string, name: string) {
        const params = this.appendParam('', 'properties', 'api');
        const headers = await this.getHeadersJson(false);
        const url = `${this.appConfig.serviceBestuurlijkeGebiedenUrl}/api/${type}/${name}/autocomplete${params}`;
        return this.makeRequest(url, 'GET', headers);
    }

    public async getWFSBestuurlijkeGebiedenByRoute(bestuurlijkeGebiedenRoute: BestuurlijkeGebiedenRoute) {
        // const params = this.appendParam('', 'properties', 'wfs');
        // const wfsPath = bestuurlijkeGebiedenRoute.route ? bestuurlijkeGebiedenRoute.route.replace(/\/api\//g, '/wfs/') : '';
        const headers = await this.getHeadersJson(); // mét token
        const url = `${this.appConfig.serviceBestuurlijkeGebiedenUrl}/wfs/${bestuurlijkeGebiedenRoute.name}`;
        return this.makeRequest(url, 'GET', headers);
    }


}